import { render, staticRenderFns } from "./veStuGraduationAuditConfigEdit.vue?vue&type=template&id=95959d2a&scoped=true"
import script from "./veStuGraduationAuditConfigEdit.vue?vue&type=script&lang=js"
export * from "./veStuGraduationAuditConfigEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95959d2a",
  null
  
)

export default component.exports